export const BORDER = {
  all: {
    color: 'grey200',
    width: 's1',
    style: 'solid',
  },
} as const

export const BORDER_RADIUS = {
  all: 'abs016',
} as const

export const ATTACHMENT_ROOT_STYLE = {
  padding: '10px',
  gap: '10px',
} as const
